import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import FilterBar from "../../../components/molecule/filter-bar/filter-bar";
import { AgGridAtom, ModalAtom } from '../../../components/atoms/atom';
import { getCategoryTableColumns } from './constant';
import { getSearchAddFilter } from '../../../utils/get-filter-items';
import { searchData } from '../../../utils/search';
import { setting } from '../../../store/services/index';
import { showToast, getFormattedDate, readFileAsync, showError } from '../../../utils/method';
import AddCategoryModal from './add/add-category';
import SettingsMenu from '../settings-menu/settings-menu';
import { AuthContext } from "../../../contexts/AuthProvider";
    
function ResourceCategoryPage() {
    const { t } = useTranslation();
    const { helpMode } = useContext(AuthContext);
    const [categoryModalView, setCategoryModalView] = useState('');
    const [selectedCategory, setSelectedCategory] = useState({});
    const [showDeleteModal, setShowdeleteModal] = useState(false);
    const filterItems = getSearchAddFilter(t, { addTextKey: 'add-category' });
    const [leftFilterItems, setLeftFilterItems] = useState(filterItems.left || []);
    const [rightFilterItems] = useState(filterItems.right || []);
    const [categoryList, setCategoryList] = useState([]);
    const [filterdCategoryList, setFilterdCategoryList] = useState([]);
    
    const fetchCategories = async () => {
        try{
            let result = await setting.getResourceCategoryWithIcons();
            result = (result?.data || []).map((record) => {
                return {
                    ...record,
                    provided: getFormattedDate(record.createdAt)
                }
            })
            setCategoryList(result);
            setFilterdCategoryList(result);
        } catch(error){
            showError(t, error);
        }
    }
    
    useEffect(() => {
        fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onCategoryEdit = (row, rowIndex) => {
        setSelectedCategory(row);
        setCategoryModalView('edit');
    };

    const onCategoryDelete = (row, rowIndex) => {
        setSelectedCategory(row);
        setShowdeleteModal(true);
    }
    const onDeleteCategory = async () => {
        try {
            const res = await setting.deleteResourceCategory(selectedCategory?.id);
            showToast(t(res?.message), { type: 'success' });
            fetchCategories();
            setShowdeleteModal(false);
        } catch(error) {
            showToast(t(error?.message), { type: 'error' });
        }
    }

    const onAddCategory = async (categoryInfo) => {
        let contentBuffer = null;
        if (categoryInfo?.iconFile) {
            if (typeof categoryInfo?.iconFile === 'string') {
                contentBuffer = categoryInfo?.iconFile;
            } else {
                contentBuffer = await readFileAsync(categoryInfo?.iconFile);
            }
        }
        try {
            const payload = {
                name: categoryInfo.name,
                icon: contentBuffer,
            };
            if (categoryModalView === 'add') {
                const res = await setting.addResourceCategory(payload);
                showToast(t(res?.message), { type: 'success' });
            } else if (categoryModalView === 'edit') {
                const res = await setting.updateResourceCategory(payload, categoryInfo.id);
                showToast(t(res?.message), { type: 'success' });
            }  
            fetchCategories();
            setCategoryModalView('');  
        } catch(error){
            showToast(t(error?.message), { type: 'error' });
        }
    }
    const categoryColumns = getCategoryTableColumns(t, onCategoryEdit, onCategoryDelete, helpMode);

    const onFilterAction = (index, key, info) => {
        if (key === 'search') {
            const localLeftFilterItems = [...leftFilterItems];
            localLeftFilterItems[1].value = info?.value;
            setLeftFilterItems(localLeftFilterItems);
            const filterCategoryList = searchData(info?.value, categoryList, categoryColumns);
            setFilterdCategoryList(filterCategoryList);
        }
        if (key === 'add') {
            setSelectedCategory({});
            setCategoryModalView('add');
        }
    };

    return (
        <>
            <SettingsMenu />
            <FilterBar 
                leftItems={leftFilterItems}
                rightItems={rightFilterItems}
                onFilterAction={onFilterAction} />

            <AgGridAtom 
                columnDefs={categoryColumns}
                rowData={filterdCategoryList}
            />

            {categoryModalView && <AddCategoryModal
                mode={categoryModalView}
                categoryInfo={selectedCategory}
                show
                onClose={() => {setCategoryModalView(''); } }
                onSubmit={onAddCategory}
            />}
            <ModalAtom 
                title={t('delete-category')} 
                body={<p>{t('delete-category-warning')}</p>}
                saveText = "delete"
                show={showDeleteModal} 
                handleClose={() => setShowdeleteModal(false) }
                handleSubmit={onDeleteCategory}
            />
        </>
    );
}

export default ResourceCategoryPage;
